import { useSelector } from 'react-redux';
import { Route, Routes, useNavigate } from 'react-router-dom';
import Spinner from '../components/Spinner/Spinner';
import ErrorBoundary from '../errorBoundary/ErrorBoundary';
import { redux } from '../reduxService';
import { useAppDispatch } from '../reduxService/hooks';
/* import RoutesMacro1 from './MacRO1/pages'; */
/* import { cleanProject } from './MacRO1/store/project/projectSlice'; */
/* import RoutesMacro2 from './Macro2/pages'; */
import './localization';
import CommonRoutes, { endpoint } from './pages';
import PageNotFound from './pages/Error/Error';
import { cleanProjectInfo } from './store/projectInfo/projectInfoSlice';
import { fetchUser, selectUser } from './store/user/userSlice';

interface IApp {}

redux.dispatch(fetchUser());

const App = (props: IApp) => {
    const user = useSelector(selectUser);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const navigateAfterError = () => {
        dispatch(cleanProjectInfo());
    /*     dispatch(cleanProject()); */
        navigate(endpoint.home);
    };

    return (
        <>
            {!user.initialState && !user.pending && !!user.data ? (
               /*  <ErrorBoundary navigate={navigateAfterError}> */
                    <Routes>
                    {/*{RoutesMacro1}
                        {RoutesMacro2} */}
                        {CommonRoutes}
                        <Route path='*' element={<PageNotFound />} />
                    </Routes>
                /* </ErrorBoundary> */
            ) : (
                <Spinner />
            )}
        </>
    );
};

export default App;
